enum TripScheduleServiceSearch {
  POPULAR = 'popular',
  SERVICE = 'service',
  EXPERIENCE = 'experience',
  ALL = 'all',
}

export { TripScheduleServiceSearch }
